import { render, staticRenderFns } from "./dashboard-negative-rank.vue?vue&type=template&id=151699a0&scoped=true&"
import script from "./dashboard-negative-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-negative-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-negative-rank.vue?vue&type=style&index=0&id=151699a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151699a0",
  null
  
)

export default component.exports